import { render, staticRenderFns } from "./memberAmountRecord.vue?vue&type=template&id=218744b3&scoped=true"
import script from "./memberAmountRecord.vue?vue&type=script&lang=js"
export * from "./memberAmountRecord.vue?vue&type=script&lang=js"
import style0 from "./memberAmountRecord.vue?vue&type=style&index=0&id=218744b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218744b3",
  null
  
)

export default component.exports